module.exports = __webpack_public_path__ + "f7d548b899a403bdb19644c3dc578646.svg";